<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "memberAnalyse",
   data(){
       return {
           
       }
   }
};
</script>

<style>
</style>